"use strict";

module.exports = {
    calledInOrder: require("./called-in-order"),
    configureLogError: require("./log_error"),
    defaultConfig: require("./default-config"),
    deepEqual: require("./deep-equal"),
    every: require("./every"),
    extend: require("./extend"),
    format: require("./format"),
    functionName: require("./function-name"),
    functionToString: require("./function-to-string"),
    getConfig: require("./get-config"),
    getPropertyDescriptor: require("./get-property-descriptor"),
    iterableToString: require("./iterable-to-string"),
    orderByFirstCall: require("./order-by-first-call"),
    restore: require("./restore"),
    timesInWords: require("./times-in-words"),
    typeOf: require("./typeOf"),
    walk: require("./walk"),
    wrapMethod: require("./wrap-method")
};
